import { createFileRoute } from '@tanstack/react-router'
import LawyerProfilesManagement from '@/views/super-admin/lawyer-profiles'

export const Route = createFileRoute('/_authenticated/super-admin-lawyer-profiles/')({
  component: LawyerProfilesManagement,
})
